import * as tslib_1 from "tslib";
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
let EdadtwentyService = class EdadtwentyService {
    constructor(http) {
        this.http = http;
        this.cargadoEdadtwenty = true;
        this.edadtwenty = [];
        this.edadtwentyRFL = [];
        this.edadtwentyRFC = [];
        this.edadtwentyRFP = [];
        this.edadtwentyRCL = [];
        this.edadtwentyRCC = [];
        this.edadtwentyRCP = [];
        this.edadtwentyRCC_PSen = [];
        this.edadtwentyRCC_PSec = [];
        this.cargarEdadtwenty();
    }
    cargarEdadtwenty() {
        return new Promise((resolve, reject) => {
            this.http.get('assets/data/dataLineas.json')
                .subscribe((resp) => {
                this.edadtwenty = resp;
                this.edadtwentyRFL = this.edadtwenty[0].rutinafacial.limpieza;
                this.edadtwentyRFC = this.edadtwenty[0].rutinafacial.cuidado;
                this.edadtwentyRFP = this.edadtwenty[0].rutinafacial.proteccion;
                this.edadtwentyRCL = this.edadtwenty[0].rutinacorporal.limpieza;
                this.edadtwentyRCC = this.edadtwenty[0].rutinacorporal.cuidado;
                this.edadtwentyRCP = this.edadtwenty[0].rutinacorporal.proteccion;
                this.edadtwentyRCC_PSen = this.edadtwenty[0].rutinacorporal.cuidado_piel_sensible;
                this.edadtwentyRCC_PSec = this.edadtwenty[0].rutinacorporal.cuidado_piel_seca;
                setTimeout(() => {
                    this.cargadoEdadtwenty = false;
                }, Math.floor(Math.random() * (1600 - 600)) + 600);
                resolve();
            });
        });
    }
};
EdadtwentyService.ctorParameters = () => [
    { type: HttpClient }
];
EdadtwentyService = tslib_1.__decorate([
    Injectable({
        providedIn: 'root'
    })
], EdadtwentyService);
export { EdadtwentyService };
//# sourceMappingURL=edadtwenty.service.js.map